import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { MASTERS_MANAGEMENT } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'

interface SystemConfigurationState {
  editObj: any
}

const initialState: SystemConfigurationState = {
  editObj: {},
}

const systemConfigurationSlice = createSlice({
  name: 'systemConfiguration',
  initialState,
  reducers: {
    setEditObj: (state, action) => {
      state.editObj = {
        ...state.editObj,
        ...action?.payload,
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clearSystemConfigurationStore: (state: any, _action) => {
      state.editObj = {}
    },
  },
})

export const { setEditObj, clearSystemConfigurationStore } = systemConfigurationSlice.actions
const systemConfigurationSelector = (state: any) => state.systemConfiguration

export const selectEditObj = createSelector(systemConfigurationSelector, (state) => state.editObj)

export const getMasterByKey = createAsyncThunk(
  'systemConfiguration/getMasterByKey',
  async (data: any) => {
    const requestedData: any = MASTERS_MANAGEMENT.SYSTEM_CONFIGURATION_CRUD.LIST(data)
    const result = await mainApiService(requestedData)
    return result
  },
)

export default systemConfigurationSlice
